import { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useParams, useSearchParams } from 'react-router-dom';
import { Input } from '../../../components/core/Input';
import Select from '../../../components/others/Select/Select';
import { PrimaryButton } from '../../../components/others/ButtonPrimary';
import LavorisService from '../../../services/LavorisService';
import StyledWrapper from './style';
import { DatePicker } from '../../../components/others/DatePicker';
import {
  maritalStatuses,
  nationalities,
  sexs
} from '../../../utils/dataOptionsUsers';
import { InputEmail } from '../../../components/others/InputEmail';
import { PhoneNumber } from '../../../components/others/PhoneNumber';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/combineReducer';
import moment from 'moment';
import { useAlert } from '../../../hooks/useAlert';
import { getErrorMessage } from '../../../utils';
import CuilRadioInput from '../../../components/others/CuilRadioInput/CuilRadioInput';
import InputCuil from '../../../components/others/InputCuil/InputCuil';
import InputRadio from '../../../components/others/InputRadio/InputRadio';

type TProps = {
  onClose: Function;
  refreshFunction?: Function;
};

export default function EditApplicant({ onClose, refreshFunction }: TProps) {
  //useState
  const { readOnly } = useSelector((state: RootState) => state.app?.modalData)
  //TODO: CAMBIAR LOS ANYs POR SUS RESPECTIVOS TIPOS
  const [applicantData, setApplicantData] = useState<any>();
  const [searchParams] = useSearchParams('');
  const [isReady, setReady] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [defaultMaritalStatus, setDefaultMaritalStatus] = useState<string>();
  const [defaultNationality, setDefaultNationality] = useState<string>();
  const [defaultOffice, setDefaultOffice] = useState<string>();
  //TODO: Sé que puedo usar un watch(), pero no está funcionando como debería en este caso. Investigar por qué.
  const [isNationality, setIsNationality] = useState<boolean>(false);
  const [defaultSex, setDefaultSex] = useState<string>();
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
    control
  } = useForm({
    mode: 'all'
  });
  const { showAlert } = useAlert();
  const LavorisInstance = LavorisService.getInstance();
  const { companies } = useSelector((state: RootState) => state.user);
  const cuil = watch('cuil') || '';
  const [hasCuil, setHasCuil] = useState(
    cuil !== '' && cuil !== undefined && cuil !== 'Pending'
  );
  const [dni, setDni] = useState(cuil.replace(/[^0-9]/g, '').substring(2, 10));
  const [data, setData] = useState<any>();
  const [docu, setDocu] = useState('')

  const getAllApplicantsCall = async () => {
    try {
      const applicants =
        await LavorisInstance.CompanyServices.getCandidatesOfCurrentCompany(companies.id ? companies.id : companies[0].id)
      if (applicants) {

        //  setTableLoading(false);
        setData(applicants);
        return applicants;
      }
    } catch (e: any) {
      console.log(e);
    }
  };

  useEffect(() => {
    setDni(cuil.replace(/[^0-9]/g, '').substring(2, 10));
    setHasCuil(cuil !== '');
  }, [cuil]);

  useEffect(() => {
    setValue('DNI', dni);
  }, [dni, setValue]);

  useEffect(() => {
    setHasCuil(cuil !== '' && cuil !== undefined && cuil !== 'Pending');
  }, [cuil]);

  // GET INDIVIDUAL APPLICANT'S PROFILE
  const getApplicantProfile = async () => {
    try {
      let applicantID = searchParams.get('rowId') || ' ';
      const applicantProfile =
        await LavorisInstance.CompanyServices.getIndividualApplicant(
          applicantID
        );
      let fullName = applicantProfile?.name?.split(',');
      const dateObject = moment(
        `${applicantProfile?.birthDate} GMT-3`,
        'DD/MM/YYYY Z'
      );
      const fechaFormateada = dateObject.format('YYYY-MM-DD[T]HH:mm:ss.SSSZ');

      if (applicantProfile) {
        setDocu(applicantProfile.DNI)
        const mappedProfile = {
          ...applicantProfile,
          name: fullName[1] ? fullName[1].trim() : fullName[0].trim(),
          lastName: fullName[1] ? fullName[0].trim() : '',
          nationalityOther: applicantProfile?.nationality,
          cuil: applicantProfile?.cuil ? applicantProfile.cuil : "",
          birthDate: fechaFormateada,
          company: companies[0].id,
          positionName: applicantProfile?.positionName,
          position: 'OTROS'
        };
        setApplicantData(mappedProfile);
        for (let [key, value] of Object.entries(mappedProfile)) {
          let name: any = key;
          value = value || '';
          setValue(name, value, {
            shouldValidate: true,
            shouldDirty: true
          });
        }
      }
      setReady(true);
    } catch (e: any) {
      console.log(e);
    }
  };

  //ADD DEFAULT VALUE TO POSITION'S SELECT DROPDOWN
  useEffect(() => {
    let defaultMaritalStatusValue = maritalStatuses.find((element: any) => {
      return element.name === applicantData?.maritalStatus;
    });
    let defaultSexValue = sexs.find((element: any) => {
      return element.name === applicantData?.sex;
    });
    let defaultNationalityValue = nationalities.find((element: any) => {
      return element.value === applicantData?.nationality;
    });

    setIsNationality(!!defaultNationalityValue);
    setDefaultMaritalStatus(defaultMaritalStatusValue?.value || 'default');
    setDefaultSex(defaultSexValue?.value || 'default');
    setDefaultNationality(defaultNationalityValue?.value || 'OTRO');
    setDefaultOffice(applicantData?.companyId);
  }, [applicantData]);

  useEffect(() => {
    getApplicantProfile();
    getAllApplicantsCall();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, useParams]);

  //const DNIsApplicants = (data && data.map((dni: any) => (dni.DNI)))

  const onSubmit = async (data: any) => {
    // if (DNIsApplicants &&
    //   DNIsApplicants.includes(data.DNI) &&
    //   docu &&
    //   docu !== data.DNI) {
    //   return showAlert(`Ya existe un Postulante con el DNI: "${data.DNI}"`)
    // }
    setIsLoading(true);
    //TODO: El back deberá guardar el nombre y el apellido
    const mappedData = {
      ...data,
      birthDate: moment(data?.birthDate).format('DD/MM/YYYY'),
      name: `${data?.lastName?.trim()}, ${data?.name?.trim()} `,
      cuil: !hasCuil ? 'Pendiente' : cuil,
      nationality: isNationality ? data.nationality : data.nationalityOther,
      isActive: data.isActive === 'Si' ? true : false,
    };

    try {
      await LavorisInstance.CompanyServices.updateApplicant(
        mappedData,
        data.id
      );
      onClose();
      refreshFunction?.();
    } catch (err: any) {
      console.log(err);
      showAlert(
        getErrorMessage({ title: 'Error al editar el candidato', err })
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleSelectNationality = (event: any) => {
    const hasNationality = nationalities.find((element: any) => {
      return (
        event.target.value === element.value && event.target.value !== 'OTRO'
      );
    });
    setIsNationality(!!hasNationality);
  };

  if (!isReady)
    return (
      <h1 className="w-full flex justify-center text-red-500 font-bolder animate-pulse">
        {' '}
        Cargando...{' '}
      </h1>
    );

  return (
    <div className="w-full h-full">
      <StyledWrapper.NameTitle>{`${applicantData?.name} ${applicantData?.lastName}`}</StyledWrapper.NameTitle>

      <form onSubmit={handleSubmit(onSubmit)}>
        <StyledWrapper.FormContainer>
          <Input
            type="text"
            label="Apellido"
            fieldName="lastName"
            register={register}
            required
            error={errors?.lastName}
            readOnly={readOnly}
          />
          <Input
            type="text"
            label="Nombre"
            fieldName="name"
            register={register}
            required
            error={errors?.name}
            readOnly={readOnly}
          />
          <CuilRadioInput hasCuil={hasCuil} setHasCuil={setHasCuil} />
          {hasCuil ? (
            <>
              <InputCuil
                label="CUIL -Sin espacios ni guiones-"
                fieldName="cuil"
                register={register}
                error={errors?.cuil}
                required={hasCuil}
                readOnly={true}
              />
              <Input
                type="text"
                label="DNI"
                fieldName="DNI"
                register={register}
                error={errors?.DNI}
                readOnly={true}
                value={dni}
              />
            </>
          ) : (
            <Input
              type="text"
              label="DNI o Pasaporte"
              fieldName="DNI"
              register={register}
              error={errors?.DNI}
              required
              readOnly={readOnly}
            />
          )}
          <DatePicker
            fieldName="birthDate"
            label={'Fecha de Nacimiento'}
            minDate={100}
            maxDate={18}
            control={control}
            required
            error={errors?.birthDate}
            readOnly={readOnly}
          />
          <Select
            fieldName="nationality"
            label="Nacionalidad"
            options={nationalities}
            //TODO: esto se podría arreglar agregando una lista dinámica de nacionalidades en el backend
            defaultValue={defaultNationality}
            register={register}
            onChange={handleSelectNationality}
            error={errors?.nationality}
            required
            styles="rounded w-full h-[50px]"
            readOnly={readOnly}
          />
          {!isNationality && (
            <>
              <p>
                Si su nacionalidad no se encuentra entre las opciones, por favor
                ingresela*
              </p>
              <Input
                type="text"
                fieldName="nationalityOther"
                label="Nacionalidad"
                register={register}
                error={errors?.nacionality}
                required
                readOnly={readOnly}
              />
            </>
          )}
          <Select
            fieldName="sex"
            label="Sexo"
            options={sexs}
            register={register}
            error={errors?.sex}
            defaultValue={defaultSex}
            required
            styles="rounded w-full h-[50px]"
            readOnly={readOnly}
          />
          <Input
            type="text"
            label="Género"
            fieldName="gender"
            register={register}
            required
            error={errors?.gender}
            readOnly={readOnly}
          />
          <Select
            fieldName="maritalStatus"
            label="Estado Civil"
            options={maritalStatuses}
            register={register}
            defaultValue={defaultMaritalStatus}
            error={errors?.maritalStatus}
            required
            styles="rounded w-full h-[50px]"
            readOnly={readOnly}
          />
          <Input
            type="text"
            label="Puesto"
            fieldName="positionName"
            register={register}
            required
            error={errors?.positionName}
            readOnly={readOnly}
          />
          {/* <Select
            fieldName="position"
            label="Puesto"
            options={jobPositions}
            register={register}
            error={errors?.position}
            required
            styles="rounded w-full h-[50px]"
          /> */}
          <InputEmail
            label="E-mail"
            nameInput={'email'}
            register={register}
            error={errors}
            required
            readOnly={readOnly}
          />
          <PhoneNumber
            control={control}
            fieldName="phoneNumber"
            label="Teléfono"
            error={errors?.phoneNumber}
            required
          />
          <InputRadio
            fieldName="isActive"
            label="Activo"
            option1="Si"
            option2="No"
            register={register}
            defaultValue={applicantData?.isActive === true ? "Si" : "No"}
          />
        </StyledWrapper.FormContainer>
        <div className="w-full flex gap-6">
          {!readOnly && (<>
            <PrimaryButton
              type="button"
              onClick={() => onClose()}
              text="Cancelar"
              styles="bg-white font-bold text-red-500 mt-8 border-red-500 border"
            />
            <PrimaryButton
              type="submit"
              text="Guardar cambios"
              styles="bg-red-500 font-bold text-white mt-8"
              disabled={isLoading}
            />
          </>)}
          {
            readOnly && (
              <PrimaryButton
                type="button"
                text="Cerrar"
                styles="bg-red-500 font-bold text-white mt-8"
                onClick={() => onClose()}
              />
            )
          }

        </div>
      </form>
    </div>
  );
}
